var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMoonSolid(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M291.9,0C150.8,0,36.5,114.6,36.5,256s114.3,256,255.4,256c69.3,0,132-27.7,178.1-72.5 c5.7-5.6,7.2-14.3,3.5-21.4c-3.7-7.1-11.5-11.1-19.4-9.7c-11.2,1.9-22.6,3-34.4,3c-110.7,0-200.6-90.1-200.6-201.1 c0-75.2,41.1-140.7,102.1-175.2c7-4,10.5-12,8.8-19.8c-1.7-7.8-8.3-13.6-16.3-14.3c-7.2-0.6-14.4-0.9-21.7-0.9L291.9,0z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoonSolid);
export default __webpack_public_path__ + "static/media/moon-solid.589dded739abfd51da18d59c6d59406a.svg";
export { ForwardRef as ReactComponent };